import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: 1,
    title: 'Limpia y Seca',
    desc: 'Asegúrate de que la piel de tu abdomen esté limpia y seca antes de aplicar.',
    img: 'https://cdn.magicpatterns.com/uploads/uQvT1kHqMRqg8QiFhRmEyz/ChatGPT_Image_Jan_22,_2026,_11_03_08_PM.png'
  }, {
    num: 2,
    title: 'Aplica el Parche',
    desc: 'Coloca StingFit sobre el ombligo o en la zona baja del abdomen antes de dormir.',
    img: 'https://cdn.magicpatterns.com/uploads/eSqPCKkytnik6c7fMVQCWm/ChatGPT_Image_Jan_22,_2026,_10_49_35_PM.png'
  }, {
    num: 3,
    title: 'Resultados Visibles',
    desc: 'Duerme tranquilamente mientras los ingredientes activos trabajan durante 8 horas.',
    img: 'https://cdn.magicpatterns.com/uploads/1SjGZqNB54e9vp3Apd26ai/ChatGPT_Image_Jan_22,_2026,_11_03_11_PM.png'
  }];
  return <Section data-id="element-389">
      <div className="text-center mb-12" data-id="element-390">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-391">
          Tan simple que se convertirá en hábito
        </h2>
        <p className="text-gray-600" data-id="element-392">
          Solo 30 segundos cada noche para transformar tu cuerpo.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-393">
        {steps.map((step, i) => <div key={i} className="flex flex-col items-center text-center group" data-id="element-394">
            <div className="relative w-full aspect-square rounded-2xl overflow-hidden mb-6 shadow-lg bg-gradient-to-br from-[#F4E4C1] to-white" data-id="element-395">
              <img src={step.img} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-396" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" data-id="element-397"></div>
              <div className="absolute top-4 left-4 w-12 h-12 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-xl shadow-lg z-10" data-id="element-398">
                {step.num}
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-399">
              {step.title}
            </h3>
            <p className="text-gray-600" data-id="element-400">{step.desc}</p>
          </div>)}
      </div>

      {/* Additional visual guide */}
      <div className="mt-12 bg-[#F4E4C1]/30 rounded-2xl p-8 border border-[#D4AF37]/20" data-id="element-401">
        <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-402">
          <div className="flex items-center gap-2" data-id="element-403">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-404">
              1
            </div>
            <span className="text-sm text-gray-700" data-id="element-405">Piel limpia</span>
          </div>
          <div className="text-gray-400" data-id="element-406">→</div>
          <div className="flex items-center gap-2" data-id="element-407">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-408">
              2
            </div>
            <span className="text-sm text-gray-700" data-id="element-409">Aplicar parche</span>
          </div>
          <div className="text-gray-400" data-id="element-410">→</div>
          <div className="flex items-center gap-2" data-id="element-411">
            <div className="w-8 h-8 bg-[#D4AF37] text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-412">
              3
            </div>
            <span className="text-sm text-gray-700" data-id="element-413">8 horas de acción</span>
          </div>
          <div className="text-gray-400" data-id="element-414">→</div>
          <div className="flex items-center gap-2" data-id="element-415">
            <span className="text-2xl" data-id="element-416">✨</span>
            <span className="text-sm font-bold text-[#2D5016]" data-id="element-417">Resultados</span>
          </div>
        </div>
      </div>
    </Section>;
}